"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementRegistry = void 0;
const class_1 = require("./shared/class");
const constructor_1 = require("./shared/constructor");
const enum_1 = require("./shared/enum");
const file_1 = require("./shared/file");
const function_1 = require("./shared/function");
const interface_1 = require("./shared/interface");
const method_1 = require("./shared/method");
const parameter_1 = require("./shared/parameter");
const property_1 = require("./shared/property");
const variable_1 = require("./shared/variable");
exports.elementRegistry = {
    class: class_1.Class,
    constant: variable_1.Variable,
    variable: variable_1.Variable,
    ctr: constructor_1.Constructor,
    enum: enum_1.Enum,
    file: file_1.File,
    function: function_1.Function,
    interface: interface_1.Interface,
    method: method_1.Method,
    parameter: parameter_1.Parameter,
    property: property_1.Property
};
